import { SupportedPlatforms } from '@smg-real-estate/domus';
import { TargetPlatform } from '@smg-real-estate/hg-search-libs';

const isPlatformIs24 = (): boolean => import.meta.env.VUE_APP_PLATFORM === 'is24';

const isPlatformHg = (): boolean => import.meta.env.VUE_APP_PLATFORM === 'hg';

const getCurrentPlatformTheme = (): SupportedPlatforms =>
  isPlatformIs24() ? SupportedPlatforms.is24 : SupportedPlatforms.hg;

const getCurrentTargetPlatform = (): TargetPlatform =>
  isPlatformIs24() ? TargetPlatform.IMMOSCOUT24 : TargetPlatform.HOMEGATE;

export { getCurrentPlatformTheme, getCurrentTargetPlatform, isPlatformHg, isPlatformIs24 };
